/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const LOCK_WITH_DOT_VIEWBOX = 46;

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/** Padlock with keyhole dot (46×46 Figma — defence no-access modal). Color via `currentColor`. */
const LockWithDotIcon = ({
  size = 46,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${LOCK_WITH_DOT_VIEWBOX} ${LOCK_WITH_DOT_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d="M11.4998 21.0833H34.4998C36.6155 21.0833 38.3332 22.801 38.3332 24.9167V36.4167C38.3332 38.5323 36.6155 40.25 34.4998 40.25H11.4998C9.38416 40.25 7.6665 38.5323 7.6665 36.4167V24.9167C7.6665 22.801 9.38416 21.0833 11.4998 21.0833V21.0833"
      stroke="currentColor"
      strokeWidth="3.45"
    />
    <path
      d="M15.3335 21.0833V13.4167C15.3335 9.18532 18.7688 5.75 23.0002 5.75C27.2315 5.75 30.6668 9.18532 30.6668 13.4167V21.0833"
      stroke="currentColor"
      strokeWidth="3.45"
    />
    <path d="M23 28.75V32.5833" stroke="currentColor" strokeWidth="3.45" />
  </svg>
);

LockWithDotIcon.propTypes = iconPropTypes;

export default LockWithDotIcon;
